var map = {
	"./concert.jpg": 721,
	"./dod.jpg": 354,
	"./dummy-image.jpg": 739,
	"./internsconnected.jpg": 651,
	"./kidchess.jpg": 415,
	"./lecture.jpg": 845,
	"./research.jpg": 712,
	"./skiing.jpg": 638,
	"./train.jpg": 373,
	"./ugascs.jpg": 521
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 760;